export default "__VITE_ASSET__CitfzLN0__"